import { combineReducers } from 'redux'

import { 
    adminGetAllUser,
    adminGetAllUserApply,
    adminGetProfile,
    adminGetUserAgenda,
    adminGetAgendaOfCounsellor,
    adminGetUserDiary,
    adminGetUserPractice,
    adminGetRooms,
    userGetRooms
 } from './adminReducer'

export default combineReducers({
    adminGetAllUser,
    adminGetAllUserApply,
    adminGetProfile,
    adminGetUserAgenda,
    adminGetAgendaOfCounsellor,
    adminGetUserDiary,
    adminGetUserPractice,
    adminGetRooms,
    userGetRooms
})